module.exports = __webpack_public_path__ + "img/notes-empty-state.5a4d6e27.svg";